module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We are grateful to the following for their help with photographs and information:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mike Back, Robert Darlaston, Don Gatehouse, Great Western Trust, Kidderminster Railway Museum, Stephen Miles, Museum of Wales, Rowland Pittard, Porthcawl Museum, Stuart Warr and Richard Woodley.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Special thanks to Ray Lawrence for information on collieries and to Tony Cooke for information on layouts, both of which have been used extensively. Thanks also to Gary Thornton for the use of information on Enthusiast Specials from his website.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every effort has been made to properly credit the photographers concerned with all the illustrations but where this has not been possible, they should contact John Hodge to rectify the situation.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("(Email: ")]), _c('a', {
    attrs: {
      "href": "mailto:john_hodge@tiscali.co.uk"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("john_hodge@tiscali.co.uk")])]), _vm._v(").")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf3df7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Acknowledgements.vue
// module id = 69
// module chunks = 0